export const SIZE_ICON_SIZE = 39;

export const SIZE_ICON_INACTIVE_COLOR = "#a9a8ae";
